import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import { getWebhooksQueryKey } from 'hooks/queries/notifications/useGetWebhooksQuery';

export const useDeleteWebhookMutation = (
  onSuccess?: () => void,
  onError?: () => void
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => {
      return apiClient.notifications.deleteWebhook({ id });
    },
    onSuccess: () => {
      queryClient
        .invalidateQueries({ queryKey: getWebhooksQueryKey() })
        .then(() => {
          notify.success('Webhook deleted successfully');
          onSuccess?.();
        });
    },
    onError: (error) => {
      notify.error(parseApiError(error));
      onError?.();
    },
  });
};
